import { Injectable } from '@angular/core';
import { HttpHeaders, HttpResponse, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError as observableThrowError, Observable, of, Subject } from 'rxjs';
import { map, flatMap, catchError } from 'rxjs/operators';

import { Parcel } from './parcel-model';
import { CreditCard, CreditCardResponse } from './payment/creditCard';




import * as FileSaver from 'file-saver';
declare var config: any;

export interface Credentials { username: string, password: string, branch: string, service: string }
export interface UserCredentials { Code: string, Name: string, ID: number, Permissions: string[], Branch: any, Service: string, UserData: any, Hash: string, Token: string }

export interface ITypeAsync {
    [index: string]: Observable<any>;
}

@Injectable()
export class DataService {
  public baseURL: string;
  public siteURL: string;
  public userData: UserCredentials|any;
    public loggedIn = false;
    public branches: any[];
    public agent_drop: boolean = false;
    public backClicked: boolean = false;
    public backProceed: boolean = false;
    public backComponent: any;
    public guestInvoice: boolean = false;
    public queue: Subject<any> = new Subject<any>();
    public queueDomestic: Subject<any> = new Subject<any>();
    public DomesticAvailable: boolean = false;
    public canadianHolidays: Date[] = [];

    addrElements = {
        street_number: 'u_house',
        route: 'u_street',
        locality: 'u_city',
        administrative_area_level_1: 'u_oblast',
        country: 'u_country',
        postal_code: 'u_index'
    };

    agentElements = {
        name: 'agentname',
        address: 'address',
        locality: 'city',
        state: 'provin_state',
        country: 'country',
        postal_code: 'pcode_zip'
    };

  constructor(private http: HttpClient) {
        var pos = config.apiPath.lastIndexOf('/api');
        if (pos > 0)
            this.baseURL = config.apiPath.substr(0, pos + 1);
        else
          this.baseURL = config.apiPath;

        this.siteURL = config.sitePath;
    }

    currencyFormatter(params) {
      return params.value.toFixed(2);
      //return "\xA3" + formatNumber(params.value);
    }

    dateFormatter(params, format) {
      return params.context.datePipe.transform(params.value, params.context.dateFormat);
    }

    get isMobileDevice() {
      var check = false;
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor);
      return check;
    };

    get UserBranch() {
        return (this.loggedIn && this.userData.UserData["u_country"].toUpperCase() == 'USA') ? 2 : 1;
    }

    get isGuest() {
        return (this.loggedIn && this.userData.UserData["customerCD"].toUpperCase() == 'GUEST');
    }

    get appService() {
        return config.service || 'All';
    }

    get useParcels() {
        let s = this.appService;
        return s == 'All' || s == 'Parcels';
    }

    get useMoney() {
        let s = this.appService;
        return s == 'All' || s == 'Money';
    }

    getPostCodes(): Observable<any> {
        return this.http.get(this.baseURL + 'api/PostCodes')
          .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getCanadianHolidays(): Observable<any> {
        return this.http.get(this.baseURL + 'api/CanadianHolidays')
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getCountries(): Observable<any> {
      return this.http.get(this.baseURL + 'api/RecieveCountries/' + this.userData.Branch.id)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getDomesticCountry(): Observable<any> {
        return this.http.get(this.baseURL + 'api/DomesticCountry/' + this.userData.Branch.id)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getDomesticTax(country: string, oblast: string): Observable<any> {
        return this.http.get(this.baseURL + `api/DomesticTax?country=${country}&oblast=${oblast}`)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getDomesticAvailable(): Observable<any> {
        return this.http.get(this.baseURL + 'api/DomesticAvailable/' + this.userData.Branch.id)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getCountryState(): Observable<any> {
      return this.http.get(this.baseURL + 'api/CountryState')
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getOblast(country: string): Observable<any> {
      return this.http.get(this.baseURL + 'api/OblastList/' + this.userData.Branch.id + '/' + country)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getMoneyCountries(): Observable<any> {
        return this.http.get(this.baseURL + 'api/MoneyCountries/' + this.userData.Branch.id)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getMoneyConfig(): Observable<any> {
        return this.http.get(this.baseURL + 'api/MoneyConfig')
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getDeliverySelection(model: any): Observable<any> {
      return this.http.post(this.baseURL + 'api/DeliverySelection/' + this.userData.Branch.id + '/' + this.userData.Code + '/' + this.userData.UserData.u_RateGroup, model)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getDiscountAmount(model: any): Observable<any> {
        return this.http.post(this.baseURL + `api/GetDiscount`, model)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getPickupSites(): Observable<any> {
        return this.http.get(this.baseURL + 'api/PickupSites/' + this.userData.Branch.id)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getCarrierPostal(): Observable<any> {
        var postal = this.userData.UserData ? this.userData.UserData.u_index : '0';
        if (!postal) postal = '0';
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
        //return this.http.post(this.baseURL + 'api/CarrierPostal', `=${postal.replace(' ', '+')}`, { headers: headers })
        return this.http.post(this.baseURL + 'api/CarrierPostal', `=${encodeURIComponent(postal)}`, { headers: headers })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    verificationEmail(email: string, how: string): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.baseURL + 'api/VerificationEmail/' + how, `=${encodeURIComponent(email)}`, { headers: headers })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    paidSMS(phone: string, id: number): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.baseURL + 'api/paidSMS/'+id, `=${encodeURIComponent(phone)}`, { headers: headers })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getMeestHub(postal: string, isEstimator?: boolean): Observable<any> {
        if (!postal) postal = '0';
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.baseURL + 'api/MeestHub/' + (isEstimator ? 0 : this.userData.Branch.id), `=${encodeURIComponent(postal)}`, { headers: headers })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getMeestAgentWH(postal: string): Observable<any> {
        if (!postal) postal = '0';
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.baseURL + 'api/MeestAgentWH/' + this.userData.Branch.id, `=${encodeURIComponent(postal)}`, { headers: headers })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getMoneyTransferSelection(model: any): Observable<any> {
        return this.http.post(this.baseURL + 'api/MoneyTransferSelection/' + this.userData.Branch.id + '/' + this.userData.Code, model)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getBranches(): Observable<any> {
      return this.http.get(this.baseURL + 'api/Portal/Branches')
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getServices(branch: string): Observable<any> {
      return this.http.get(this.baseURL + 'api/Portal/Services/' + branch)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getPaymentMethods(shipmentType: string): Observable<any> {
        return this.http.get(this.baseURL + `api/PaymentMethods/${this.userData.Branch.id}/${this.userData.UserData.u_type}/${this.userData.UserData.u_subtype}/${shipmentType}`)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getParcels(): Observable<any> {
        return this.http.get(this.baseURL + `api/Parcels/${this.userData.ID}/${this.userData.Branch ? this.userData.Branch.id : 0}/${this.userData.UserData.u_type}/${this.userData.UserData.u_subtype}`, { withCredentials: true })
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getSingleParcel(parcelid: number, isMoney: boolean): Observable<any> {
        var method = isMoney ? 'MTData' : 'Parcel';
        return this.http.get(this.baseURL + `api/${method}/${parcelid}/${this.userData.Branch ? this.userData.Branch.id : 0}/${this.userData.ID}`)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getPhoneSender(phone: string): Observable<any> {
        if (this.isGuest)
            return of(null);
      else return this.http.get(this.baseURL + `api/PhoneSearchSender/${this.userData.ID}/${phone}`)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getPhoneRecipient(phone: string): Observable<any> {
        if (this.isGuest)
            return of(null);
      else return this.http.get(this.baseURL + `api/PhoneSearchRecipient/${this.userData.ID}/${phone}`)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getInsuranceAmount(): Observable<any> {
      return this.http.get(this.baseURL + `api/InsuranceAmount/${this.userData.Branch.id}`)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getItemGroups(): Observable<any> {
      return this.http.get(this.baseURL + 'api/ItemGroups')
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getItemGroupsFrequent(): Observable<any> {
        return this.http.get(this.baseURL + 'api/ItemGroupsFrequent')
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getDiscounts(phone: string, email: string, code: string): Observable<any> {
      let p = { Phone: phone, Email: email, Code: code, branchID: this.userData.Branch.id };
      return this.http.post(this.baseURL + 'api/Discounts', p)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getDiscountsMT(phone: string, email: string, code: string): Observable<any> {
        let p = { Phone: phone, Email: email, Code: code, branchID: this.userData.Branch.id };
        return this.http.post(this.baseURL + 'api/DiscountsMT', p)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    usPaymentCors(arg: string): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post('https://secure.thebankcardgroupgateway.com/api/transact.php', arg, { headers: headers })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    usPayment(card: CreditCard): Observable<any> {
        return this.http.post(this.baseURL + 'api/USPayment', card)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    directPay(cc: any): Observable<any> {
        return this.http.post(this.baseURL + 'api/PartnerPayRequest', { CreditCard:cc, User:this.userData.UserData})
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    saveParcel(model: Parcel, isCarrier: boolean): Observable<any> {
        var carr = isCarrier ? 1 : 0;
      return this.http.post(this.baseURL + `api/SaveParcel/${this.userData.UserData.u_type}/${this.userData.UserData.u_RateGroup}/${this.userData.Branch.currency}/${this.userData.Branch.weight}/${this.userData.Branch.dimension}/${carr}`, model)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    saveParcelItem(id: number, model: any[]): Observable<any> {
      return this.http.post(this.baseURL + 'api/SaveParcelItem/'+id, model)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    saveSignature(id: number, sigdata: any): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('TargetService', 'MeestPortal');
        return this.http.post(`${this.siteURL}Agent/AddSignature?partial=none`, { id: id, signature: sigdata, action: window.opener ? 'email' : '' }, { headers: headers })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    saveMoney(model: Parcel): Observable<any> {
        return this.http.post(this.baseURL + `api/SaveMoney/${this.userData.UserData.u_type}/${this.userData.UserData.u_RateGroup}/${this.userData.Branch.currency}`, model)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getMoneyOccupations(): Observable<any> {
        return this.http.get(this.baseURL + 'api/MT/Occupations')
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getMoneyPurposes(): Observable<any> {
        return this.http.get(this.baseURL + 'api/MT/Purposes')
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    startKycSession(userId: number, email: string, fname: string, lname: string): Observable<any> {
        const body = { UserId: userId, Email: email, FirstName: fname, LastName: lname };
        return this.http.post(this.baseURL + 'api/KYC/StartSession', body)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getKycSessionStatus(refId: string): Observable<any> {
        return this.http.get(this.baseURL + 'api/KYC/SessionStatus/' + refId)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    fetchKycResult(refId: string): Observable<any> {
        return this.http.post(this.baseURL + 'api/KYC/FetchResult/' + refId, null)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

  saveBarcode(parcel: number, code: string): Observable<any> {
    return this.http.post(this.baseURL + 'api/UpdateBarcode/' + parcel + '/' + code, null)
      .pipe(catchError((error) => { return this.handleError(error); }));
  }

  checkBarcode(code: string): Observable<any> {
    if (!code || code == '')
      return of(null);
    else return this.http.get(this.baseURL + 'api/CheckBarcode/' + code)
      .pipe(catchError((error) => { return this.handleError(error); }));
  }

    senderHistory(): Observable<any> {
        return this.http.get(this.baseURL + `api/SenderHistory/${this.userData.ID}`)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    savePayment(parcelid: number, card: CreditCard, billAddress?: boolean): Observable<any> {
        return this.http.post(this.baseURL + `api/Payment/${parcelid}/${this.userData.Branch.id}/${this.userData.ID}/${this.userData.Branch.currency}/${billAddress ? 1 : 0}`, card)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    savePaymentGuest(parcelid: number, card: CreditCard, billAddress: boolean, bill: any): Observable<any> {
        return this.http.post(this.baseURL + `api/PaymentGuest/${parcelid}/${this.userData.Branch.id}/${this.userData.ID}/${this.userData.Branch.currency}/${billAddress ? 1 : 0}`, { card: card, bill: bill })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getPaymentResult(parcelid: number): Observable<any> {
      return this.http.get(this.baseURL + 'api/PaymentResult/' + parcelid)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getInvoice(parcelid: number, isMoney: boolean): Observable<any> {
        var url = isMoney ? 'Money/Invoice' : (this.isMobileDevice ? 'Agent/InvoiceNarrow' : 'Agent/InvoiceNarrow');
        //var url = isMoney ? 'Money/Invoice' : 'Agent/Invoice';
        return this.http.get(`${this.siteURL}${url}/${parcelid}?partial=${this.userData.Branch ? this.userData.Branch.id : 0}-${this.userData.UserData.id}&inline=${this.isGuest ? 'G' : 'Y'}`, { responseType: 'text' })
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    deleteParcel(parcelid: number): Observable<any> {
        return this.http.post(`${this.siteURL}Agent/DeleteParcel/${parcelid}`, '', { responseType: 'text' })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    downloadInvoice(invId: number, parcelCode: string) {
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (!isSafari)
        return;

      //this.http.get(`${this.siteURL}Agent/PrintParcel/${invId}?cn23=0&partial=${this.userData.Branch.id}-${this.userData.ID}`, { headers: new Headers({ 'Content-Type': 'application/json' }), responseType: ResponseContentType.Blob })
      this.http.get(`${this.siteURL}Agent/PrintParcelNarrow/${invId}?partial=${this.userData.Branch.id}-${this.userData.ID}`, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'blob' })
        .subscribe((response) => { // download file
          var blob = new Blob([response], { type: 'application/pdf' });
          //if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //    window.navigator.msSaveOrOpenBlob(blob);
          //}
          //else {
          //    var objectUrl = URL.createObjectURL(blob);
          //    window.open(objectUrl);
          //}
          var filename = `${parcelCode}.pdf`;
          FileSaver.saveAs(blob, filename);
        });
    }

    downloadInvoiceAsync(invId: number, isMoney: boolean) {
        var url = isMoney ? 'Money/PrintPayment' : 'Agent/PrintParcelNarrow';
      //return this.http.get(`${this.siteURL}Agent/PrintParcel/${invId}?cn23=0&partial=${this.userData.Branch.id}-${this.userData.ID}`, { headers: new Headers({ 'Content-Type': 'application/json' }), responseType: ResponseContentType.Blob })
      return this.http.get(`${this.siteURL}${url}/${invId}?partial=${this.userData.Branch.id}-${this.userData.ID}`, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'blob' })
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    downloadLabelAsync(invId: number): Observable<any> {
        return this.http.get(`${this.siteURL}Agent/PrintLabel/${invId}?is4x8=false&partial=${this.userData.Branch.id}-${this.userData.UserData.id}`, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'blob' })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    sendCompleteEmail(invId: number, status: string, isMoney: boolean) {
        return this.http.get(`${this.siteURL}Agent/SendCustomerEmail/${invId}?partial=${this.userData.Branch.id}-${this.userData.ID}-${status}&isMoney=${isMoney ? 1 : 0}`, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getAgentList(country: string, lat: number, lon: number): Observable<any> {
        return this.http.get(this.baseURL + `api/AgentListDist/${country}?lat=${lat}&lon=${lon}`)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getAgent(code: string): Observable<any> {
        return this.http.get(this.baseURL + 'api/Agent/' + code)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getClosestAgent(lat: number, lon: number, country: string): Observable<any> {
        var c = country ? `&country=${country}` : '';
        return this.http.get(this.baseURL + `api/ClosestAgent?lat=${lat}&lon=${lon}${c}`)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getDocList(code: string): Observable<any> {
        return this.http.get(this.baseURL + 'api/DocList/List/' + code)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getDocument(name: string): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.baseURL + 'api/DocList/Get/', `=${encodeURIComponent(name)}`, { headers: headers, responseType: 'blob' })
            .pipe(catchError((error) => { return this.handleErrorBlob(error); }));
    }

    deleteDoc(code: string, num: string): Observable<any> {
        return this.http.delete(this.baseURL + `api/DocList/Delete/${code}/${num}`)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getShipForDoc(code: string): Observable<any> {
        return this.http.get(this.baseURL + 'api/ParcelForDocUpload/' + code)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    saveIdList(param: any): Observable<any> {
        return this.http.post(this.baseURL + 'api/UpdateIdList', param)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getCPRates(param: any): Observable<any> {
        return this.http.post(this.baseURL + 'api/CanadaPostRates', Object.assign({ BranchID: this.userData.Branch.id }, param))
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getPostRates(param: any): Observable<any> {
        return this.http.post(this.baseURL + 'api/GetPostRates', Object.assign({ BranchID: this.userData.Branch.id }, param))
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getExpressPostRates(param: any): Observable<any> {
        return this.http.post(this.baseURL + 'api/GetExpressPostRates', Object.assign({ BranchID: this.userData.Branch.id }, param))
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    saveCPShipment(param: any, shipType: string): Observable<any> {
        return this.http.post(this.baseURL + 'api/SaveCanadaPostShipment/' + shipType, Object.assign({ BranchID: this.userData.Branch.id }, param))
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getCPShipment(id: number): Observable<any> {
        return this.http.get(this.baseURL + 'api/GetCanadaPostShipment/' + id)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    createCPShipment(param: any): Observable<any> {
        return this.http.post(this.baseURL + 'api/CanadaPostShipment', Object.assign({ BranchID: this.userData.Branch.id }, param))
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getCPLabel(param: any): Observable<any> {
        return this.http.post(this.baseURL + 'api/CanadaPostLabel', Object.assign({ BranchID: this.userData.Branch.id }, param), { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'blob' })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    sendDWShipment(id: number): Observable<any> {
        return this.http.get(this.baseURL + 'api/DW/Parcel/' + id)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getFixedRates(): Observable<any> {
        return this.http.get(this.baseURL + 'api/CarrierFixedRates/' + this.userData.Branch.id)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    checkpoint(chkpt: number): Observable<any> {
        let point = { UserEmail: this.userData.UserData.u_email, CheckpointTypeID: chkpt };
        return this.http.post(this.baseURL + 'api/Checkpoint', point)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    numPrepaid(): Observable<any> {
        if (!this.userData || !this.userData.UserData || !this.userData.UserData.id)
            return of(0);
        return this.http.get(this.baseURL + 'api/PrepaidParcels/' + this.userData.UserData.id)
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    saveParcelAgent(id: number, code: string): Observable<any> {
        return this.http.post(this.baseURL + `api/ParcelAgent/${id}/${code}`, '')
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    getTypeahead(query: string): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.baseURL + `api/ItemTypeahead`, '=' + query, { headers: headers })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    insertQuestions(questions: any[], page: string): Observable<any> {
      return this.http.post(this.baseURL + 'api/UI/Insert/' + page, questions)
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    userProfile(model: any): Observable<any> {
        return this.http.post(this.baseURL + 'api/Portal/UserProfile', model, { withCredentials: true })
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    register(model: any): Observable<any> {
        return this.http.post(this.baseURL + 'api/Portal/Registration', model, { withCredentials: true })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    completeReg(model: any): Observable<any> {
        return this.http.post(this.baseURL + 'api/Portal/CompleteReg', model, { withCredentials: true })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    login(credentials: Credentials): Observable<any> {
        return this.http.post(this.baseURL + 'api/Portal/Login', credentials, { withCredentials: true });
    }

    loginGuest(credentials: Credentials): Observable<any> {
        return this.http.post(this.baseURL + 'api/Portal/LoginGuest', credentials, { withCredentials: true });
    }

    resetPassword(credentials: Credentials): Observable<any> {
        return this.http.post(this.baseURL + 'api/Portal/ResetPassword', credentials, { withCredentials: true })
            .pipe(catchError((error) => { return this.handleError(error); }));
    }

    loginEncrypted(credenc: string): Observable<any> {
      let headers = new HttpHeaders();
       headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
       return this.http.post(this.baseURL + 'api/Portal/LoginEncrypted', '=' + credenc, { headers: headers, withCredentials: true })
        .pipe(catchError((error) => { return this.handleError(error); }));
    }

    parseUserAddress(user_addrComp: any, source?: any) {
        let from = source ? source : this.userData.UserData;
        let addrComp = [];
        for (var p in this.addrElements) {
            var el = from[this.addrElements[p]];
            if (el && el != '') {
                addrComp.push(el);
                user_addrComp[p] = el;
            }
        }
        return addrComp;
    }

    parseAgentAddress(ag: any, agent_addrComp: any) {
        let addrComp = [];
        for (var p in this.agentElements) {
            var el = ag[this.agentElements[p]];
            if (el && el != '') {
                addrComp.push(el);
                agent_addrComp[p] = el;
            }
        }
        return addrComp;
    }

hasClass(el, className) {
    if (el.classList)
        return el.classList.contains(className);
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
}

addClass(el, className) {
    if (el.classList)
        el.classList.add(className)
    else if (!this.hasClass(el, className))
        el.className += " " + className;
}

removeClass(el, className) {
    if (el.classList)
        el.classList.remove(className)
    else if (this.hasClass(el, className)) {
        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
        el.className = el.className.replace(reg, ' ');
    }
}
    processError(err: any): string {
        var errorMessage: string;
        if (err.ExceptionMessage) {
            errorMessage = err.ExceptionMessage;
            var ex = err.InnerException;
            while (ex) {
                errorMessage += (" => " + ex.ExceptionMessage);
                ex = ex.InnerException;
            }
        }
        else if (err.Message)
            errorMessage = err.Message;
        else if (err.message)
            errorMessage = err.message;
        else
            errorMessage = err;

        return errorMessage;
    }

    public handleError(error: any) {
    if (error.status == 500) {
        var jerr = error.error;
        //if (jerr && jerr.ExceptionMessage === 'UnauthorizedException')
        //    this.messengerService.statusChanged('UnauthorizedException');
        //else
        return observableThrowError(jerr || 'Server error');
    }
    else
      return observableThrowError({ Message: error.status + ' ' + error.statusText });
    }

    handleErrorBlob(err: HttpErrorResponse): Observable<any> {
        const reader: FileReader = new FileReader();

        const obs = Observable.create((observer: any) => {
            reader.onloadend = (e) => {
                observer.error(JSON.parse(<string>reader.result));
                observer.complete();
            }
        });
        reader.readAsText(err.error);
        return obs;
    }
}
